import React, { useEffect, useState } from "react";
import { Button, TextField, Box, Select, MenuItem, InputLabel, FormControl, OutlinedInput, Chip, Checkbox, ListItemText } from "@mui/material";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import MasterViewController from "../../redux/actions/masterApiActions";
import FormDrawer from "../../components/layout/FormDrawer";
import "../../styles/styles.css";
import "../../styles/layout.css";

const COMMON_ACTIONS = ["view", "create", "edit", "delete", "approve", "export", "import", "archive", "restore", "assign", "unassign", "generate_report", "reject"];

const MenuProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
    },
  },
};

const MODULE_CHOICES = [
    { key: "dashboard", label: "Dashboard" },
    { key: "oragnizations", label: "Oragnizations Management" },
    { key: "company_list", label: "Oragnizations List" },
    { key: "employer_management", label: "Employers List" },
    { key: "employee_management", label: "Employees Management" },
    { key: "employee_list", label: "Employee List" },
    { key: "attendance_management", label: "Attendances" },
    { key: "leave", label: "Leave Management" },
    { key: "leave_list", label: "List" },
    { key: "leave_balance", label: "Leave Balance" },
    { key: "holidays", label: "Holiday Calendar" },
    { key: "salaries", label: "Salaries" },
    { key: "payrolls", label: "Payroll Management" },
    { key: "pay_slips", label: "Payslip Management" },
    { key: "report_management", label: "Report Management" },
    { key: "compliance", label: "Compliance" },
    { key: "challan_master", label: "Challan Master" },
    { key: "tax_slab", label: "Tax Slab Configuration" },
    { key: "masters", label: "Master Configuration" },
    { key: "roles", label: "Role Management" },
    { key: "employer_master", label: "Employer Master" },
    { key: "departments", label: "Department Management" },
    { key: "designations", label: "Designation Management" },
    { key: "holiday_master", label: "Holiday Master" },
    { key: "oragnization_holiday_management", label: "Holiday Management" },
    { key: "projects", label: "Projects" },
    { key: "project_list", label: "Project List" },
    { key: "task_issues_management", label: "Tasks & Issues" },
    { key: "notifications", label: "Announcements" },
    { key: "employee_attendance", label: "Employee Attendance" },
    { key: "employee_payslips", label: "Employee payslips" },
    { key: "employee_task_issue", label: "Employee Task & Issue" },
    { key: "appraisals", label: "Appraisals" },
    { key: "appraisal_cycle", label: "Appraisal Cycle" },
    { key: "reviews", label: "Reviews" },
    { key: "appraisal_reviews", label: "Appraisal Review" },
    { key: "contract", label: "Contract" },
    { key: "contract_terms_conditions", label: "Contract Term & Conditions" },
    { key: "contract_managment", label: "Contract Managment" },
    { key: "employee_tax_slab", label: "Employee Tax Slab " },
    { key: "genrate_documents", label: "Documents" },
    { key: "subscripation_plans", label: " Subscripation Plans" },
    { key: "shift_master", label: "Shift Master" },
    { key: "assign_shift", label: "Assign Shift" },
    { key: "module_master", label: "Module Master" }
];

function ModuleMasterFormModal({ show, handleClose, initialData = null }) {
  const dispatch = useDispatch();
  const { addPermissionMaster, updatePermissionMaster } = MasterViewController();
  const isEdit = Boolean(initialData?.id);

  const [initialValues, setInitialValues] = useState({
    module_name: "",
    module_key: "",
    available_actions: []
  });

  useEffect(() => {
    if (show && initialData) {
      setInitialValues({
        module_name: initialData.module_name || "",
        module_key: initialData.module_key || "",
        available_actions: initialData.available_actions || []
      });
    } else if (show && !initialData) {
      setInitialValues({
        module_name: "",
        module_key: "",
        available_actions: []
      });
    }
  }, [show, initialData]);

  const handleSubmit = (values, { resetForm }) => {
    const action = isEdit
      ? updatePermissionMaster(initialData.id, values)
      : addPermissionMaster(values);

    dispatch(action)
      .then(() => {
        resetForm();
        handleClose();
      })
      .catch((error) => {
        console.error("Error submitting module form:", error);
      });
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, handleChange, handleBlur, submitForm, setFieldValue }) => (
        <Form style={{ display: "contents" }}>
          <FormDrawer
            open={show}
            onClose={handleClose}
            title={isEdit ? "Edit Permission Module" : "Add Permission Module"}
            subtitle={isEdit ? "Update module details" : "Add a new module"}
            footer={
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, width: "100%" }}>
                <Button onClick={handleClose} variant="outlined" color="secondary">
                  Cancel
                </Button>
                <Button 
                  type="button" 
                  variant="contained" 
                  color="primary" 
                  onClick={() => submitForm()}
                >
                  {isEdit ? "Update" : "Submit"}
                </Button>
              </Box>
            }
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 1 }}>
              <TextField
                label="Module Name *"
                name="module_name"
                value={values.module_name}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                variant="outlined"
              />
              <TextField
                label="Module Key (e.g. leave_management) *"
                name="module_key"
                value={values.module_key}
                onChange={handleChange}
                onBlur={handleBlur}
                fullWidth
                variant="outlined"
                disabled={isEdit}
              />

              <FormControl fullWidth variant="outlined">
                <InputLabel id="available-actions-label">Available Actions</InputLabel>
                <Select
                  labelId="available-actions-label"
                  id="available-actions"
                  multiple
                  name="available_actions"
                  value={values.available_actions}
                  onChange={handleChange}
                  input={<OutlinedInput id="select-multiple-chip" label="Available Actions" />}
                  MenuProps={MenuProps}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} size="small" />
                      ))}
                    </Box>
                  )}
                >
                  {COMMON_ACTIONS.map((action) => (
                    <MenuItem 
                      key={action} 
                      value={action}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: "transparent",
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        }
                      }}
                    >
                      <Checkbox checked={values.available_actions.indexOf(action) > -1} />
                      <ListItemText primary={action} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </FormDrawer>
        </Form>
      )}
    </Formik>
  );
}

export default ModuleMasterFormModal;
